var Header = function() {
		var comp = $('[data-component="header"]');
		var self = this;

		self.validationMessages = null;

    function init() {
			self.validationMessages = new ValidationMessages();
			addListeners();
			optionsSettings();
    }

    function addListeners() {
			// Abre e fecha o menu de linguagens
			comp.find('.select').click(function() {

				var toggle = $(this).next('.options');

				if(toggle.height() != 0) {
					TweenMax.to(toggle, .2, {height: 0});
					$(this).removeClass('open');
				}
				else {
					TweenMax.to(toggle, .2, {height: toggle.attr('initH')});
					$(this).addClass('open');
				}
			});

			//Define a linguagem selecionada
			comp.find('.option').click(function() {
				var option = $(this).data('option');
				var optionText = $(this).text();

				localStorage.setItem("language", option);
				self.validationMessages.changeMessages();

				comp.find('.language-current').attr('data-option', option);
				comp.find('.language-current').text(optionText);

				TweenMax.to($(this).closest('.options'), .2, {height: 0});

				comp.find('.option').removeClass('current');
				$(this).addClass('current');
			});
    }

    //Define o estilo inicial para o menu de linguagens, assim abrirá corretamente
    function optionsSettings() {
			var toggle = comp.find('.options');
			toggle.attr('initH', toggle.height());
			TweenLite.set(toggle, {height:0, visibility:"visible"});

			var option = 'en';
			if (localStorage.language) {
				option = localStorage.language;
			}
			var optionText = comp.find('[data-option="' + option + '"]').text();

			comp.find('.language-current').attr('data-option', option);
			comp.find('.language-current').text(optionText);

			comp.find('[data-option="'+ option +'"]').addClass('current');
		}

    return init();
}

$(document).ready(function() {
	if ($('[data-component="header"]').length > 0) {
		new Header();
	}
});
